import React, { useEffect, useState } from "react";
import Navbar from "../../component/Navbar/Navbar";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import axios from "axios";
import { BACKEND_BASEURL } from "../../db/baseUrl";
import CashierSale from "./CashierSale";
import useRedirectLogoutUser from "../../CustomHook/useRedirectLogoutUser";

const currentAndLastMonthValue = ["days", "weeks"];
const lastWeekValue = ["days"];
const last3MonthValue = ["weeks", "months"];

const Dashboard = () => {
  useRedirectLogoutUser("/login");
  const [lastWeekSale, setLastWeekSale] = useState(0);
  const [totalSale, setTotalSale] = useState(0);
  const [lastMonthSale, setLastMonthSale] = useState(0);
  const [daysSale, setDaysSale] = useState();
  const [weeksSale, setWeeksSale] = useState();
  const [monthsSale, setMonthsSale] = useState();
  const [todaySale, setTodaySale] = useState(0);
  const [barChartData, setBarChartData] = useState();
  const [topSelling, setTopSelling] = useState();
  const [timeFrame, setTimeFrame] = useState("currentMonth");
  const [limit, setLimit] = useState("3");
  const [saleTimeFrame, setSaleTimeFrame] = useState("currentMonth");
  const [saleTimeFrameVarieties, setSaleTimeFrameVarieties] = useState(
    currentAndLastMonthValue
  );

  const getTotalSaleLastWeek = async () => {
    try {
      const response = await axios.get(
        `${BACKEND_BASEURL}api/orders/getTotalSaleLastWeek`
      );
      const fetchedData = response.data;
      setLastWeekSale(fetchedData.totalSale);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "An unexpected error occurred";
      console.log(message);
    }
  };
  const getTotalSaleToday = async () => {
    try {
      const response = await axios.get(
        `${BACKEND_BASEURL}api/orders/getTotalSaleToday`
      );
      const fetchedData = response.data;
      setTodaySale(fetchedData.totalSale);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "An unexpected error occurred";
      console.log(message);
    }
  };
  const getTotalSaleLastMonth = async () => {
    try {
      const response = await axios.get(
        `${BACKEND_BASEURL}api/orders/getTotalSaleLastMonth`
      );
      const fetchedData = response.data;
      setLastMonthSale(fetchedData.totalSale);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "An unexpected error occurred";
      console.log(message);
    }
  };
  const getTotalSale = async () => {
    try {
      const response = await axios.get(
        `${BACKEND_BASEURL}api/orders/getTotalSale`
      );
      const fetchedData = response.data;
      setTotalSale(fetchedData.totalSale);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "An unexpected error occurred";
      console.log(message);
    }
  };
  const getTopSelling = async (timeFrame, limit) => {
    try {
      const response = await axios.get(
        `${BACKEND_BASEURL}api/orders/getTopSelling/${timeFrame}/${limit}`
      );
      const fetchedData = response.data;
      setTopSelling(fetchedData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "An unexpected error occurred";
      console.log(message);
    }
  };
  useEffect(() => {
    getTotalSaleLastWeek();
    getTotalSale();
    getTotalSaleLastMonth();
    getTotalSaleToday();
    // getTopSelling();
  }, []);

  useEffect(() => {
    getTopSelling(timeFrame, limit);
  }, [limit, timeFrame]);
  const getOrdersCurrentMonth = async () => {
    try {
      const response = await axios.get(
        `${BACKEND_BASEURL}api/orders/getOrdersCurrentMonth`
      );
      const fetchedData = response.data;
      setWeeksSale(fetchedData.weeks);
      setDaysSale(fetchedData.days);
      setBarChartData(fetchedData.days);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "An unexpected error occurred";
      console.log(message);
    }
  };

  const getOrdersLastMonth = async () => {
    try {
      const response = await axios.get(
        `${BACKEND_BASEURL}api/orders/getOrdersLastMonth`
      );
      const fetchedData = response.data;
      setWeeksSale(fetchedData.weeks);
      setDaysSale(fetchedData.days);
      setBarChartData(fetchedData.days);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "An unexpected error occurred";
      console.log(message);
    }
  };

  const getOrdersLastWeek = async () => {
    try {
      const response = await axios.get(
        `${BACKEND_BASEURL}api/orders/getOrdersLastWeek`
      );
      const fetchedData = response.data;
      setDaysSale(fetchedData.lastWeek);
      setBarChartData(fetchedData.lastWeek);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "An unexpected error occurred";
      console.log(message);
    }
  };

  const getOrdersLastThreeMonths = async () => {
    try {
      const response = await axios.get(
        `${BACKEND_BASEURL}api/orders/getOrdersLastThreeMonths`
      );
      const fetchedData = response.data;
      setWeeksSale(fetchedData.weeks);
      setMonthsSale(fetchedData.months);
      setBarChartData(fetchedData.weeks);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "An unexpected error occurred";
      console.log(message);
    }
  };

  useEffect(() => {
    if (saleTimeFrame === "currentMonth") {
      setSelectedValue("days");
      getOrdersCurrentMonth();
      setSaleTimeFrameVarieties(currentAndLastMonthValue);
    }
    if (saleTimeFrame === "lastMonth") {
      setSelectedValue("days");
      getOrdersLastMonth();
      setSaleTimeFrameVarieties(currentAndLastMonthValue);
    }
    if (saleTimeFrame === "lastWeek") {
      setSelectedValue("days");
      getOrdersLastWeek();
      setSaleTimeFrameVarieties(lastWeekValue);
    }
    if (saleTimeFrame === "last3Month") {
      setSelectedValue("weeks");
      getOrdersLastThreeMonths();
      setSaleTimeFrameVarieties(last3MonthValue);
    }
  }, [saleTimeFrame]);

  const [selectedValue, setSelectedValue] = useState();

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  useEffect(() => {
    if (selectedValue === "days") {
      setBarChartData(daysSale);
    }
    if (selectedValue === "weeks") {
      setBarChartData(weeksSale);
    }
    if (selectedValue === "months") {
      setBarChartData(monthsSale);
    }
  }, [daysSale, weeksSale, monthsSale, selectedValue]);

  const priceSymbol = process.env.REACT_APP_PRICE_SYMBOL;
  return (
    <div>
      <Navbar page={"Dashboard"} />
      <div>
        <div className="flex justify-center gap-6 flex-wrap my-10 items-center w-[90%] mx-auto">
          <div className="w-[16rem]  h-[7rem] rounded-2xl shadow-md  bg-white">
            <div className="w-full  h-full rounded-2xl flex flex-col justify-between p-4  leading-none font-bold items-start capitalize font-inter text-[1.2rem] shadow-inner  bg-white">
              <div>total sale</div>
              <div>
                {priceSymbol} {totalSale}
              </div>
            </div>
          </div>
          <div className="w-[16rem]  h-[7rem] rounded-2xl shadow-md  bg-white">
            <div className="w-full  h-full rounded-2xl flex flex-col justify-between p-4  leading-none font-bold items-start capitalize font-inter text-[1.2rem] shadow-inner  bg-white">
              <div>last month sale</div>
              <div>
                {priceSymbol} {lastMonthSale}
              </div>
            </div>
          </div>
          <div className="w-[16rem]  h-[7rem] rounded-2xl shadow-md  bg-white">
            <div className="w-full  h-full rounded-2xl flex flex-col justify-between p-4  leading-none font-bold items-start capitalize font-inter text-[1.2rem] shadow-inner  bg-white">
              <div>last week sale</div>
              <div>
                {priceSymbol} {lastWeekSale}
              </div>
            </div>
          </div>
          <div className="w-[16rem]  h-[7rem] rounded-2xl shadow-md  bg-white">
            <div className="w-full  h-full rounded-2xl flex flex-col justify-between p-4  leading-none font-bold items-start capitalize font-inter text-[1.2rem] shadow-inner  bg-white">
              <div>today sale</div>
              <div>
                {priceSymbol} {todaySale}
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-[80%] md:w-[85%] w-full shadow-inner rounded-3xl  mx-auto my-10">
          <div className=" w-full p-4 mx-auto shadow-lg rounded-3xl ">
            <div className="flex justify-between items-center m-4">
              <h2 className="text-lg font-semibold   p-2 w-max ">
                Sales by{" "}
                {saleTimeFrame === "currentMonth"
                  ? "Current Month"
                  : saleTimeFrame === "lastWeek"
                  ? "Last Week"
                  : saleTimeFrame === "lastMonth"
                  ? "Last Month"
                  : "Last Three Month"}
              </h2>
              <select
                value={saleTimeFrame}
                onChange={(e) => setSaleTimeFrame(e.target.value)}
                className="outline-none  border w-[15rem] p-2 rounded-md"
              >
                <option value="currentMonth">Current Month</option>
                <option value="lastWeek">Last Week</option>
                <option value="lastMonth">Last Month</option>
                <option value="last3Month">Last 3 Month</option>
              </select>
            </div>
            <div className="flex justify-end mr-4 ">
              <select
                className="outline-none border capitalize p-1 rounded-md"
                value={selectedValue}
                onChange={handleChange}
              >
                {saleTimeFrameVarieties.map((item, i) => (
                  <option value={item} className=" capitalize">
                    {item}
                  </option>
                ))}
              </select>
            </div>
            <div className="lg:h-[24rem] h-[20rem] w-full">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart
                  data={barChartData}
                  margin={{
                    top: 20,
                    right: 30,
                    left: -20,
                    bottom: 5,
                  }}
                >
                  <XAxis
                    dataKey="name"
                    style={{ fontSize: "10px", fill: "#0D868C" }}
                  />
                  <YAxis style={{ fontSize: "10px", fill: "#0D868C" }} />
                  <Tooltip contentStyle={{ fontSize: "12px" }} />
                  <Legend
                    wrapperStyle={{ fontSize: "10px" }}
                    payload={[
                      {
                        value:
                          selectedValue === "days"
                            ? "Day Sale"
                            : selectedValue === "weeks"
                            ? "Week Sale"
                            : "Month Sale",
                        type: "circle",
                        color: "#0D868C",
                      },
                      // { value: "Orders", type: "circle", color: "#F59E0B" },
                    ]}
                  />
                  <Bar
                    dataKey="totalSale"
                    fill="#0D868C"
                    barSize={
                      selectedValue === "weeks"
                        ? 70
                        : selectedValue === "months"
                        ? 100
                        : 10
                    }
                    activeShape={null}
                  />
                  {/* <Bar
                    dataKey="totalSale"
                    fill="#0D868C"
                    barSize={5}
                    activeShape={null}
                  />
                  <Bar
                    dataKey="orders"
                    fill="#F59E0B"
                    barSize={5}
                    activeShape={null}
                  /> */}
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-row-reverse  gap-4 justify-between items-end mx-auto lg:w-[80%] md:w-[85%] w-full mt-20  pb-20">
        <div className=" lg:w-[40%] w-[50%]  shadow-inner rounded-xl">
          <div className="w-full p-5 shadow-lg rounded-xl">
            <CashierSale />
          </div>
        </div>
        <div className=" lg:w-[55%] w-[50%] h-[17.5rem] overflow-y-auto scrollbar-hide rounded-xl shadow-lg ">
          <div className=" w-full rounded-xl shadow-inner p-4">
            <div className="sticky top-0 bg-white py-2  flex lg:flex-row md:flex-col  justify-between lg:items-center items-start gap-2">
              <h2 className="text-lg font-semibold capitalize  p-2 ">
                top selling product
              </h2>
              <div className="flex justify-end w-full gap-2">
                <select
                  className="outline-none  p-2  capitalize"
                  value={timeFrame}
                  onChange={(e) => setTimeFrame(e.target.value)}
                >
                  <option value="currentMonth">Current Month</option>
                  <option value="lastWeek">Last Week</option>
                  <option value="lastMonth">Last Month</option>
                  <option value="last3Months">Last 3 Month</option>
                </select>
                {/* <input
                type="text"
                className="outline-none border p-[.45rem] rounded-md capitalize "
                placeholder="enter no. of product"
              /> */}
                <select
                  className="outline-none capitalize p-2 "
                  value={limit}
                  onChange={(e) => setLimit(e.target.value)}
                >
                  <option value="3">3</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                </select>
              </div>
            </div>
            <div className="flex flex-col gap-4 m-4">
              {
                // topSelling?.lenght > 1 ? (
                topSelling?.map((item, i) => (
                  <div className="flex items-center justify-between border-b last:border-none pb-4">
                    <div className="flex items-center justify-start gap-4 capitalize">
                      <span
                        className={`py-2 w-10 rounded-full flex items-center justify-center text-white font-semibold ${
                          i === 0
                            ? "bg-[#80FF00]"
                            : i === 1
                            ? "bg-[#FFBF00]"
                            : i === 2
                            ? " bg-[#8B0000]"
                            : "bg-slate-200"
                        } `}
                      >
                        {i + 1}
                      </span>
                      <span>{item.name}</span>
                    </div>
                    <span>{item.totalQuantity}</span>
                  </div>
                ))
                // ) : (
                //   <div>No</div>
                // )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
